import router from "./index";

export default [
  {
    path: "/teachers",
    component: () => import('../views/Teacher/Teacher'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") != "admin")
        router.replace("/home");
      else
        next();
    },
    meta: {
      title: '教师管理'
    },
    children: [
      {
        path: '/',
        redirect: 'TeaList'
      },
      {
        path: 'TeaList',
        component: () => import('../views/Teacher/Tealist/TeaList'),
        meta: {
          title: '教师列表'
        },
      },
      {
        path: 'AddTeacher',
        component: () => import('../views/Teacher/AddTeacher/Addteacher'),
        meta: {
          title: '添加教师'
        },
      },
    ]
  },
]
